<script lang="ts">
  import { cards, delete_card } from './observables'
  import { getContext } from 'svelte'
  import Confirmation from '../Confirmation/Component.svelte'
  import Card from './Component.svelte'
  import CtaButton from '../Generic/CtaButton.svelte'
  import { goto } from '@roxi/routify'
  import type { Component, ComponentProps } from '../utilities/typeHelpers'

  const {
    open,
  }: {
    open: (component: Component<Confirmation>, props: ComponentProps<Confirmation>) => void
  } = getContext('simple-modal')
  const showDeleteConfirmation = (id: string) =>
    open(Confirmation as unknown as Component<Confirmation>, {
      action: () => $delete_card(id),
      message: 'Are you sure you want to delete this card?',
    })
</script>

{#if !$cards}
  <p>Loading...</p>
{:else}
  <div class="grid">
    {#each $cards as card (card.id)}
      <Card
        {...card}
        show_buttons
        on_delete_button={() => {
          showDeleteConfirmation(card.id)
        }}
      />
    {/each}
  </div>
  <div id="new-card-fab">
    <CtaButton on:click={() => void $goto('/cards/new')}>Add Card</CtaButton>
  </div>
{/if}

<style>
  .grid {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(26em, 1fr));
    gap: 1em;
    margin-top: 1em;
    padding-left: 1em;
    padding-right: 1em;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 7em;
  }

  #new-card-fab {
    position: fixed;
    right: 4em;
    bottom: 4em;
  }
</style>
